/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Control_Track_2chInputs */



/**
* | output |
* | --- |
* | "2-channel WAV: AD narration + control (WHP 198)" |
*
* @param {Audio_Description_Export_Control_Track_2chInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_control_track_2ch = /** @type {((inputs?: Audio_Description_Export_Control_Track_2chInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Control_Track_2chInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("WAV 2 canaux : narration AD + contrôle (WHP 198)")
	if (locale === "de") return /** @type {LocalizedString} */ ("2-Kanal-WAV: AD-Sprecher + Steuerung (WHP 198)")
	if (locale === "it") return /** @type {LocalizedString} */ ("WAV a 2 canali: narrazione AD + controllo (WHP 198)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("2-канальный WAV: озвучка АД + управление (WHP 198)")
	if (locale === "es") return /** @type {LocalizedString} */ ("WAV de 2 canales: narración de AD + control (WHP 198)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("双声道 WAV：AD 旁白 + 控制（WHP 198）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("2ch WAV：AD ナレーション + コントロール（WHP 198）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("2-चैनल WAV: AD नैरेशन + कंट्रोल (WHP 198)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("WAV de 2 canais: narração de AD + controlo (WHP 198)")
	return /** @type {LocalizedString} */ ("2-channel WAV: AD narration + control (WHP 198)")
});